import React, { useCallback, useEffect, useState } from 'react';
import moment from 'moment';

import { PageContainer, ContainerDataTable } from '../../../../styles/styles';
import FormContainer from '../../../../components/FormContainer';
import Button from '../../../../components/Button';
import DataTableMui from '../../../../components/DataTableMui';
import DatepickerMui from '../../../../components/Inputs/DatepickerMui';
import Icon from '../../../../components/Icons';
import Modal from '../../../../components/Modal';
import PageLoader from '../../../../components/PageLoader';
import { useGlobal } from '../../../../contexts/Global/context';
import { generatePDFCoop } from '../../../../services';
import { cloneObject, downloadFile } from '../../../../utils';
import { schema } from './schema';
import * as S from './styles';

function DemonstrativoCoparticipacao({ location: { dataBeneficiario } }) {
    const [filterValues, setFilterValues] = useState({
        ...cloneObject(schema),
    });
    const [alreadySearched, setAlreadySearched] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [irData, setIrData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);

    const { contrastTheme } = useGlobal();

    async function loadData() {
        setLoading(true);

        // const yearOptions = (await loadYears()) || [];

        const initialValues = {
            ...filterValues,
        };

        setFilterValues({
            ...filterValues,
            ...initialValues,
        });

        setLoading(false);
    }

    useEffect(() => {
        loadData();
    }, []);

    async function downloadReport(row) {
        setLoading(true);
        const body = {
            cabecalho: {
                empresaOrigemAtendimento: '1',
                divisaoNegocio: '1',
                unidadeNegocio: '1',
                canal: 'M',
                origemContrato: '1',
                tipoContrato: '1',
                codigoEmpresaOrigem: '1',
                token: ' ',
            },
            credencial: row.numCarteira,
            mes: row.mes,
            perfil: 'BENEFICIARIO',
            ano: row.ano,
            nomeEmpresa: row.empresa,

            // teste pra mock
            // credencial: '9123897600000001000',
            // mes: '10',
            // perfil: 'BENEFICIARIO',
            // ano: '2022',
            // empresa: 'teste',
        };

        const response = await generatePDFCoop(body);

        if (!response.response && response.type !== 'application/pdf') {
            setShowModal(true);
            setLoading(false);
            return;
        }

        const file = window.URL.createObjectURL(response);
        downloadFile(`${row.numCarteira}_demonstrativo_coop.pdf`, file);
        setLoading(false);
    }

    async function doSearchOnly() {
        setIsLoading(true);

        const data = [
            {
                credencial: dataBeneficiario.numCarteira,
                numCarteira: dataBeneficiario.numCarteira,
                nomeCompleto: dataBeneficiario.nomeCompleto,
                cpf: dataBeneficiario.cpf,
                empresa: dataBeneficiario.empresa.nome,
                tipoBeneficiario: dataBeneficiario.tipo,
                tipoDemonstrativo: filterValues.fileType.lookup,
                ano: moment(filterValues.year.value).format('YYYY'),
                mes: moment(filterValues.month.value).format('MM'),
            },
        ];

        setIrData(data);
        setIsLoading(false);
    }

    const [columnsHead, setColumnsHead] = useState([
        {
            key: 'numCarteira',
            selector: (row) => row.numCarteira,
            name: 'Número da carteira',
            sortable: true,
            direction: 'left',
            customStyles: () => ({ padding: '0 16px 0 24px', width: '200px' }),
        },
        {
            key: 'nomeCompleto',
            selector: (row) => row.nomeCompleto,
            name: 'Nome completo',
            sortable: true,
            direction: 'left',
            customStyles: () => ({ padding: '0 16px 0 24px', width: '200px' }),
        },
        {
            key: 'cpf',
            selector: (row) => row.cpf,
            name: 'CPF',
            sortable: true,
            direction: 'left',
            customStyles: () => ({ padding: '0 16px 0 24px', width: '200px' }),
        },
        {
            key: 'tipoBeneficiario',
            selector: (row) => row.tipoBeneficiario,
            name: 'Tipo beneficiário',
            sortable: true,
            direction: 'left',
            customStyles: () => ({ padding: '0 16px 0 24px', width: '200px' }),
        },
        {
            key: 'download',
            selector: (row) => row,
            name: 'Download',
            sortable: true,
            direction: 'center',
            mutation: (row) => (
                <S.CellWithIcon>
                    <Icon
                        name="file_download"
                        color={contrastTheme ? '#FFF333' : '#EC6E0C'}
                        onClick={() => downloadReport(row)}
                        tooltip={<S.TooltipText>Baixar arquivo gerado</S.TooltipText>}
                        size={22}
                    />
                </S.CellWithIcon>
            ),
            customStyles: () => ({ padding: '0 16px 0 24px', width: '200px' }),
        },
    ]);

    function handleColumns() {
        const newCollumnsHead = [...columnsHead];

        setColumnsHead([...newCollumnsHead]);
    }

    async function handleGenerateColumns() {
        setIsLoading(true);

        if (
            typeof filterValues.year.value !== 'undefined' &&
            typeof filterValues.month.value !== 'undefined' &&
            filterValues.month.value.length &&
            filterValues.year.value.length
        ) {
            await doSearchOnly();
        }

        handleColumns();

        setIsLoading(false);
        setAlreadySearched(true);
    }

    function handleChangeInput(event) {
        const { id, value, ...rest } = event;

        const field = { ...filterValues[id], value, error: '', ...rest };

        const editedForm = { ...filterValues, [id]: field };

        setFilterValues(editedForm);
    }
    const handleClickClearAll = useCallback(() => {
        setIrData([]);

        const oldFilterValues = filterValues;

        delete oldFilterValues.year.value;
        delete oldFilterValues.month.value;

        setFilterValues({ ...oldFilterValues });
    }, [irData, filterValues]);

    return (
        <>
            <PageContainer>
                <S.SearchContainer>
                    <FormContainer>
                        <DatepickerMui
                            field={filterValues?.month}
                            openTo="month"
                            format="MM"
                            placeholder="MM"
                            views={['month']}
                            onChange={handleChangeInput}
                        />
                        <DatepickerMui
                            field={filterValues?.year}
                            openTo="year"
                            format="yyyy"
                            placeholder="AAAA"
                            views={['year']}
                            onChange={handleChangeInput}
                        />
                    </FormContainer>
                    <S.SearchButton type="primary" onClick={handleGenerateColumns}>
                        Gerar PDF
                    </S.SearchButton>
                </S.SearchContainer>
                {irData.length > 0 && (
                    <S.LinkButtonRegister id="clearRegisters" onClick={handleClickClearAll}>
                        <span className="active">Limpar registros</span>
                    </S.LinkButtonRegister>
                )}
            </PageContainer>

            <ContainerDataTable>
                <DataTableMui
                    alreadySearched={alreadySearched}
                    columns={columnsHead}
                    data={irData}
                    emptyMessage="Dados não encontrados."
                    loading={isLoading}
                />
            </ContainerDataTable>
            <Modal
                title="Atenção"
                subtitle="Não foi possível gerar o demonstrativo de coparticipação, por gentileza entrar em contato com a NDI."
                visible={showModal}
                onCancel={() => setShowModal(false)}
                footer={null}
            >
                <Button
                    type="primary"
                    onClick={() => {
                        setShowModal(false);
                    }}
                >
                    Entendi
                </Button>
            </Modal>
            <PageLoader loading={loading} message="Gerando o demonstrativo de coparticipação... Aguarde." />
        </>
    );
}

export default DemonstrativoCoparticipacao;
